import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { signOut } from "../../redux/actions/authActions";
import logo from "../../resources/logo.svg";
import LangToggle from "../utils/LangToggle";

const NavMenu = () => {
  const navRef = useRef();
  const uid = useSelector((store) => store.firebase.auth.uid);
  const profile = useSelector((store) => store.firebase.profile);
  const lang = useSelector((store) => store.options.lang);

  const dispatch = useDispatch();

  const handleMouseOver = () => {
    if (window.innerWidth > 992) {
      navRef.current.classList.add("in");
    }
  };

  const handleMouseOut = () => {
    navRef.current.classList.remove("in");
  };

  return (
    <>
      <NavMenuStyled>
        <nav ref={navRef}>
          <ul
            className="navbar-nav"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            <li className="logo">
              <Link to="/" className="nav-link brand" onClick={handleMouseOut}>
                <span className="link-text">RAURU</span>
                <img src={logo} className="app-logo" alt="logo" />
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={handleMouseOut}>
                <i className="fas fa-home"></i>
                <span className="link-text">{lang.data.menu.home}</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/blog" className="nav-link" onClick={handleMouseOut}>
                <i className="fab fa-microblog"></i>
                <span className="link-text">Blog</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about_me"
                className="nav-link"
                onClick={handleMouseOut}
              >
                <i className="fas fa-id-card"></i>
                <span className="link-text">{lang.data.menu.about}</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={handleMouseOut}>
                <i className="far fa-envelope"></i>
                <span className="link-text">{lang.data.menu.contact}</span>
              </Link>
            </li>

            {uid ? (
              <>
                {profile.role >= 5 && (
                  <li className="nav-item">
                    <Link
                      to="/admin"
                      className="nav-link"
                      onClick={handleMouseOut}
                    >
                      <i className="fas fa-pen-square"></i>
                      <span className="link-text">Admin</span>
                    </Link>
                  </li>
                )}

                <li className="nav-item lang-toggle">
                  <LangToggle />
                </li>
                <li className="nav-item">
                  <a
                    href="/"
                    className="nav-link"
                    onClick={() => {
                      dispatch(signOut());
                      handleMouseOut();
                    }}
                  >
                    <i className="fas fa-door-open"></i>
                    <span className="link-text">Sign Out</span>
                  </a>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item lang-toggle">
                  <LangToggle />
                </li>
                {/* <li className="nav-item">
                  <Link
                    to="/signup"
                    className="nav-link"
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    onClick={handleMouseOut}
                  >
                    <i className="fas fa-door-closed"></i>
                    <span className="link-text">Sign In</span>
                  </Link>
                </li> */}
              </>
            )}
          </ul>
        </nav>
      </NavMenuStyled>
    </>
  );
};

const NavMenuStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 8rem;
  height: 100vh;
  box-shadow: 1px 1px 10px 1px var(--gray);
  z-index: 100;
  nav {
    height: 100%;
    width: 100%;
    background: var(--white);
    transition: width 300ms ease;

    .navbar-nav {
      height: 100%;
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .nav-item,
      .logo {
        display: flex;
        width: 100%;
      }
      .nav-item {
        justify-content: flex-start;

        :hover {
          background: var(--light-gray);
        }
      }
      .lang-toggle {
        display: none;
        @media (min-width: 992px) {
          display: flex;
          margin-top: auto;
          width: 100%;
          justify-content: center;
          padding: 1rem 0;
          a {
            width: 100%;
            text-decoration: none;
            font-weight: bold;
            text-align: center;
          }
        }
      }

      .logo {
        height: 8rem;
        margin-bottom: 4rem;
        justify-content: flex-end;
        background: var(--mainColor);
        .link-text {
          font-weight: bold;
          font-family: var(--specialFont);
        }
        .nav-link {
          height: 100%;
          width: 100%;
          color: var(--white);
        }
        .app-logo {
          height: 90%;
          margin-right: 0.2rem;
        }
        box-shadow: 0 3px 10px -1px var(--gray);
      }
      .nav-link {
        display: flex;
        justify-content: left;
        align-items: center;
        height: 5rem;
        color: var(--gray);
        text-decoration: none;
        .link-text {
          transition-delay: 310ms;
          opacity: 0;
          margin-left: 1rem;
          font-size: 0;
          transition: opacity 10ms ease;
        }
        i {
          min-width: 2.6rem;
          font-size: 2.6rem;
          margin: 0 2rem;
          color: var(--mainColor);
        }
        :hover {
          .link-text {
            font-weight: bold;
            font-size: 2.4rem;
          }
          transition: 1.2s;
        }
      }

      a.brand {
        justify-content: space-around;
        .link-text {
          margin-left: 0;
        }
      }
    }
  }
  nav.in {
    transition: width 300ms ease;
    width: 24rem;
    box-shadow: 2px 2px 10px 5px var(--gray);

    .nav-item {
      margin-right: auto;
    }

    .nav-link {
      text-decoration: none;
      .link-text {
        transition-delay: 310ms;
        opacity: 100%;
        font-size: 2rem;
      }
    }

    a.brand {
      margin-left: 4rem;
      justify-content: space-between;
      .link-text {
        margin-left: 2rem;
      }
    }
  }

  @media (max-width: 992px) {
    height: 8rem;
    width: 100vw;
    bottom: 0;
    top: auto;
    left: 0;
    .navbar-nav {
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      li.logo {
        display: none;
      }

      li.nav-item {
        margin: 0;
        width: 7rem;
        height: 100%;
        align-items: center;
      }
    }
  }
`;

export default NavMenu;
